import { render, staticRenderFns } from "./influencer_bio_slide_setting_modal.vue?vue&type=template&id=2c47410b&scoped=true&"
import script from "./influencer_bio_slide_setting_modal.vue?vue&type=script&lang=js&"
export * from "./influencer_bio_slide_setting_modal.vue?vue&type=script&lang=js&"
import style0 from "./influencer_bio_slide_setting_modal.vue?vue&type=style&index=0&id=2c47410b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47410b",
  null
  
)

export default component.exports